











































































































































































import BaseComponent from '../../../core/base.component';
import Component from 'vue-class-component';
import { InquiryDto, InquiryListDto } from '../../../dto';
import { Pagination, INQUIRY, CONST_INQUIRY } from '../../../common';
import InquiryService from '../../../services/inquiry.service';
import {
  ClearOutQueryParamMapper,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core';

@Component({
  name: 'InquiryList',
})
export default class InquiryList extends BaseComponent {
  private inquiryList: InquiryDto[] = [];
  private inquirySearchDto = new InquiryListDto();
  private inquiryTotalCount = null;
  private pagination = new Pagination();
  private dataLoading = false;
  private inquiryTypeSelect: INQUIRY[] = [...CONST_INQUIRY];

  findAll(isPagination?: boolean, isSearch?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1;
    } else {
      if (isSearch) this.pagination.page = 1;
      RouterQueryParamMapper(this.inquirySearchDto, this.pagination);
    }
    InquiryService.findAll(this.inquirySearchDto, this.pagination).subscribe(
      res => {
        if (res) {
          this.dataLoading = false;
          this.inquiryList = res.data.items;
          this.inquiryTotalCount = res.data.totalCount;
        }
      },
    );
  }

  paginateSearch() {
    this.findAll(true);
  }

  search() {
    this.findAll(true, true);
  }

  clearOut() {
    if (location.search) {
      ClearOutQueryParamMapper();
    } else {
      this.inquirySearchDto = new InquiryListDto();
      this.findAll();
    }
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.inquirySearchDto = query;
      if (!isNaN(+query.limit) && !isNaN(+query.page)) {
        this.pagination.limit = +query.limit;
        this.pagination.page = +query.page;
      } else {
        this.pagination = new Pagination();
      }
      this.paginateSearch();
    } else {
      this.findAll();
    }
  }
}
